import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=1279bdd0"
import script from "./Route.vue?vue&type=script&lang=js"
export * from "./Route.vue?vue&type=script&lang=js"
import style0 from "./Route.vue?vue&type=style&index=0&id=1279bdd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports